export const setUnvisitedPlacesNearbyCount = ({
  placeCount,
  isLoading,
}) => state => {
  return {
    ...state,
    unvisitedPlacesNearby: {
      ...state.unvisitedPlacesNearby,
      pagination: {
        ...state.unvisitedPlacesNearby.pagination,
        isLoading:
          isLoading === undefined
            ? state.unvisitedPlacesNearby.pagination.isLoading
            : isLoading,
        itemCount: placeCount,
        pageCount: Math.ceil(
          placeCount / state.unvisitedPlacesNearby.pagination.pageSize,
        ),
      },
    },
  };
};
